export default {
  template: '#page-not-found',
  props: [],
  data() {
    return {
    }
  }
}
